import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Card, Table, Loader, Icon} from 'semantic-ui-react';
import {Actions} from '../../../common/actions';

class Abbreviations extends Component {
  handleEditClick(parameter) {
    this.props.selectSequenceConfigAbbreviation(parameter);
    const abbreviationInput = document.getElementById('sequence-abbreviation');

    if (abbreviationInput) {
      abbreviationInput.focus();
    }
  }

  getProviderName(parameter) {
    if (parameter.sequentialType !== 'PROVEEDOR') {
      return parameter.sequentialName;
    }

    const {providers = []} = this.props;
    const selectedProvider = providers.find((provider) => provider.code === parameter.sequentialName);

    return !selectedProvider ? `${parameter.sequentialName} - SIN ORIGEN` : selectedProvider.name;
  }

  renderBody() {
    const {loading, configValues} = this.props;
    
    if (loading) {
      return (
        <Table.Row>
          <Table.Cell colSpan='4'>
            <Loader active inline='centered' />
          </Table.Cell>
        </Table.Row>
      );
    }

    if (!configValues.length) {
      return (
        <Table.Row>
          <Table.Cell colSpan='4' textAlign='center'>
            No se encontraron parámetros.
          </Table.Cell>
        </Table.Row>
      );
    }

    return configValues.map((parameter, index) => {
      return (
        <Table.Row key={index}>
          <Table.Cell>{parameter.sequentialType}</Table.Cell>
          <Table.Cell>{this.getProviderName(parameter)}</Table.Cell>
          <Table.Cell textAlign='center'>{parameter.abbreviation}</Table.Cell>
          <Table.Cell textAlign='center'>
            <Icon link name='write' color='blue' size='large' onClick={() => this.handleEditClick(parameter)} />
          </Table.Cell>
        </Table.Row>
      );
    });
  }

  render() {
    return (
      <Card fluid className='parameters-visualization'>
        <div className='providers-sequence-parameters'>
          <Table>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>Tipo</Table.HeaderCell>
                <Table.HeaderCell>Nombre</Table.HeaderCell>
                <Table.HeaderCell>Abreviación</Table.HeaderCell>
                <Table.HeaderCell>Acciones</Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {this.renderBody()}
            </Table.Body>
          </Table>
        </div>
      </Card>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'configValues': state.providerSequenceConfig.configValues,
  };
};

const {selectSequenceConfigAbbreviation} = Actions;

export default connect(mapStateToProps, {selectSequenceConfigAbbreviation})(Abbreviations);
